import { render, staticRenderFns } from "./PerfilAgenciaSection.vue?vue&type=template&id=48529da0&scoped=true"
import script from "./PerfilAgenciaSection.vue?vue&type=script&lang=js"
export * from "./PerfilAgenciaSection.vue?vue&type=script&lang=js"
import style0 from "./PerfilAgenciaSection.vue?vue&type=style&index=0&id=48529da0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48529da0",
  null
  
)

export default component.exports